import { z } from 'zod';
export const snowplowChangeFormEventSchemaV1 = z
    .object({
    formId: z.string().min(0).max(4096).describe('The id of the form the element belongs to'),
    elementId: z.string().min(0).max(4096).describe('The id of the element that has just received focus'),
    nodeName: z.enum(['INPUT', 'TEXTAREA', 'SELECT']).describe('The node type of the element'),
    type: z
        .enum([
        'button',
        'checkbox',
        'color',
        'date',
        'datetime',
        'datetime-local',
        'email',
        'file',
        'hidden',
        'image',
        'month',
        'number',
        'password',
        'radio',
        'range',
        'reset',
        'search',
        'submit',
        'tel',
        'text',
        'time',
        'url',
        'week',
    ])
        .describe('The type of input element')
        .optional(),
    elementClasses: z
        .union([
        z
            .array(z.string().min(0).max(4096).describe('A class on the element'))
            .describe('An array of the classes on the element'),
        z.null().describe('An array of the classes on the element'),
    ])
        .describe('An array of the classes on the element')
        .optional(),
    value: z
        .union([
        z.string().min(0).max(65535).describe('The value of the element when it gained focus'),
        z.null().describe('The value of the element when it gained focus'),
    ])
        .describe('The value of the element when it gained focus'),
})
    .strict()
    .describe('{"description":"Schema for a form field\'s value being changed","_schema_key":"iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0","meta":{"schemaType":"event"}}');
//# sourceMappingURL=data:application/json;base64,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